import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Brand";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-navy outline-none transition focus:border-navy focus:ring-2 focus:ring-navy/20";

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-4" data-testid="admin-login-page">
      <img
        src="https://images.unsplash.com/photo-1698998882426-39a6609ab10a"
        alt="Tow truck carrying a vehicle"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-navy-900/95 via-navy/85 to-navy/70" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(217,164,65,0.18),transparent_55%)]" />
      <div className="relative z-10 w-full max-w-md">
        <a href="/" className="mb-6 inline-flex items-center gap-2 text-sm font-semibold text-white/70 hover:text-white">
          <ArrowLeft size={16} /> Back to site
        </a>
        <div className="rounded-2xl bg-white p-8 shadow-2xl">
          <Logo />
          <div className="mt-6 flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy-50 text-navy"><Lock size={18} /></span>
            <div>
              <h1 className="font-display text-xl font-black text-navy">Admin Login</h1>
              <p className="text-xs text-muted-foreground">Manage quotes & shipments</p>
            </div>
          </div>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className={field} />
            <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className={field} />
            {error && <p className="rounded-lg bg-red-50 px-4 py-2.5 text-sm text-brandred" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-btn" className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-brandred px-6 py-3.5 text-sm font-bold text-white transition-transform hover:bg-brandred-700 active:scale-95 disabled:opacity-60">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock size={16} />} Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
